import { render, staticRenderFns } from "./SwitchDialog.vue?vue&type=template&id=5cfb7dfa&"
import script from "./SwitchDialog.vue?vue&type=script&lang=js&"
export * from "./SwitchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports